import { METRICTYPE } from 'src/utils/entityDefinitions';
import { VariationsMetricsByWeekRecord } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/ContentServerProxy/types';

export interface GetEntityMetadataResponseRecord {
  id: string;
  title: string;
  subtitle: string;
  translatedTitles: string;
  brandName: string;
  brandId: number;
  categoryName: string;
  categoryId: number;
  subCategoryName: string;
  subCategoryId: number;
  retailerSku: string;
  stacklineSku: string;
  upc: string;
}

export enum VariationsFilter {
  ChildVariationRate = 'ChildVariationRate',
  SingleSkuPages = 'SingleSkuPages',
  VariatedSkuPages = 'VariatedSkuPages',

  ChildAccuracy = 'ChildAccuracy',
  CorrectChildSkus = 'CorrectChildSkus',
  IncorrectChildSkus = 'IncorrectChildSkus',

  ParentPageAccuracy = 'ParentPageAccuracy',
  InaccurateParentPages = 'InaccurateParentPages',
  PageDensity = 'PageDensity',
  ParentPageCount = 'ParentPageCount'
}

export enum VariationsTopThreeFilter {
  VariationRate = 'variationRate',
  ChildAccuracy = 'childAccuracy',
  PageDensity = 'pageDensity'
}

export interface VariationsMetricFormatterProps {
  showFullValue: boolean;
  decimalPlaces: number;
  valueMetricType: METRICTYPE;
}

export interface VariationsGaugeData {
  percentage?: number;
  change?: number;
  absoluteChange?: number;
  value: number;
  valueSuffix?: string;
  filterKey: VariationsFilter;
  valueMetricFormatter?: VariationsMetricFormatterProps;
  numerator?: number;
  denominator?: number;
}

export interface VariationsPerformanceGaugeData {
  gaugeData: VariationsGaugeData[];
  variationsMetricsRecords?: VariationsMetricsByWeekRecord[];
}

export interface VariationPerformanceMetrics {
  childVariationRate: number;
  accuracyRate: number;
  pageDensity: number;
  parentPageAccuracy: number;
  singleSkuCount: number;
  variatedSkuCount: number;
  correctChildCount: number;
  incorrectChildCount: number;
  inaccurateParentCount: number;
}

export const VariationTilesHeaders = {
  [VariationsFilter.ChildVariationRate]: {
    default: 'CHILD VARIATION RATE',
    product: 'CHILD VARIATION RATE'
  },
  [VariationsFilter.SingleSkuPages]: {
    default: 'UNVARIATED CHILD SKUS',
    product: 'UNVARIATED CHILD SKUS'
  },
  [VariationsFilter.VariatedSkuPages]: {
    default: 'VARIATED CHILD SKUS',
    product: 'VARIATED CHILD SKUS'
  },
  [VariationsFilter.ChildAccuracy]: {
    default: 'CHILD SKU ACCURACY',
    product: 'CHILD SKU ACCURACY'
  },
  [VariationsFilter.IncorrectChildSkus]: {
    default: 'INACCURATE CHILD SKUS',
    product: 'INACCURATE CHILD SKUS'
  },
  [VariationsFilter.CorrectChildSkus]: {
    default: 'ACCURATE CHILD SKUS',
    product: 'ACCURATE CHILD SKUS'
  },
  [VariationsFilter.ParentPageAccuracy]: {
    default: 'PARENT PAGE ACCURACY',
    product: 'PARENT PAGE ACCURACY'
  },
  [VariationsFilter.InaccurateParentPages]: {
    default: 'INACCURATE PARENT PAGES',
    product: 'INACCURATE PARENT PAGES'
  },
  [VariationsFilter.PageDensity]: {
    default: 'PAGE DENSITY',
    product: 'PAGE DENSITY'
  },
  [VariationsFilter.ParentPageCount]: {
    default: 'PARENT PAGE COUNT',
    product: 'PARENT PAGE COUNT'
  }
};
